define.alias("shared/helpers/format-datetime", "settings/helpers/format-datetime");